import {
  CContainer,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import Establishment from "../../models/establishment";
import EstablishmentForm from "./EstablishmentForm";

interface EstablishmentUpdateModalProps {
  show: boolean;
  establishment?: Establishment;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const EstablishmentUpdateModal: React.FC<EstablishmentUpdateModalProps> = ({
  show,
  establishment,
  onCancel,
  onSuccess,
}) => {
  const modalTitle = establishment
    ? `Editar Establecimiento: ${establishment.code}`
    : `Agregar Establecimiento`;

  const onClose = () => {
    onCancel();
  };

  return (
    <CModal show={show} onClose={onClose} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>{modalTitle}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          {show ? (
            <EstablishmentForm
              establishment={establishment}
              onCancel={onCancel}
              onSuccess={onSuccess}
              clearOnSuccess={false}
            />
          ) : (
            <></>
          )}
        </CContainer>
      </CModalBody>
    </CModal>
  );
};

export default EstablishmentUpdateModal;
